import modalIframe from './iframe'

const Modal = {}

Modal.iframe = function (config) {
  return modalIframe(config)
}

export default Modal
